module.exports = __webpack_public_path__ + "static/media/q-led-mini_en.05393112.pdf";